module.exports = __webpack_public_path__ + "img/location-arrow.82bbef34.svg";